import { Injectable } from "@angular/core";
import { IStatEvent, IStatSummary } from "@comunicare/comunicare-interfaces";
import { IUserStatisticsService } from "@comunicare/comunicare-interfaces-dashboard-services";

/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
@Injectable({
  providedIn: "root",
})
export class UserStatisticsService implements IUserStatisticsService {
  listSummaries(from: string, to: string): Promise<IStatSummary[]> {
    throw new Error("Method not implemented.");
  }
  updateStatSummary(statToIncrement: string): Promise<IStatSummary> {
    return null;
  }
  createStatEvent(eventDescription: string, servicesIds?: string[], careplansIds?: string[]): Promise<IStatEvent> {
    return null;
  }
}
